import request from 'tools/request'

export const getStateOptions = async () => {
  const res = await request.get(`${process.env.REACT_APP_CARRIER_API_URL}commonresource/statelist`)
  return res?.data
}
